//Vendors
import { NavLink } from 'react-router-dom'

export const Tab: React.FC<any> = ({ label, ...rest }) => (
  <NavLink {...rest}>
    <span className="tab_label">{label}</span>
    <i className="tab_line d-block" />
  </NavLink>
)
